import { HttpClient } from '@wix/sdk-types';
import {
  CalculateTotalsOptions,
  CalculateTotalsResponse,
  CalculateTotalsResponseNonNullableFields,
  calculateTotals as universalCalculateTotals,
} from './ecom-v1-totals-calculation-totals-calculator.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function calculateTotals(
  httpClient: HttpClient
): CalculateTotalsSignature {
  return (options?: CalculateTotalsOptions) =>
    universalCalculateTotals(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface CalculateTotalsSignature {
  /**
   * Returns a totals calculation for specified line items.
   */
  (options?: CalculateTotalsOptions | undefined): Promise<
    CalculateTotalsResponse & CalculateTotalsResponseNonNullableFields
  >;
}

export {
  AdditionalFee,
  AdditionalFeeSource,
  Address,
  AddressLocation,
  AggregatedTaxBreakdown,
  ApiV1AdditionalFee,
  ApplicableLineItems,
  ApplicationError,
  AppliedDiscount,
  AppliedDiscountDiscountSourceOneOf,
  AutoTaxFallbackCalculationDetails,
  CalculateTotalsOptions,
  CalculateTotalsRequest,
  CalculateTotalsRequestCouponOneOf,
  CalculateTotalsRequestGiftCardOneOf,
  CalculateTotalsResponse,
  CalculateTotalsResponseNonNullableFields,
  CalculatedLineItem,
  CalculationErrors,
  CalculationErrorsShippingCalculationErrorOneOf,
  Carrier,
  CarrierError,
  CarrierErrors,
  CarrierServiceOption,
  CarrierShippingOption,
  CatalogReference,
  ChargeType,
  Coupon,
  DataFetchType,
  DeliveryAllocation,
  DeliveryLogistics,
  DeliveryTimeSlot,
  Details,
  DetailsKindOneOf,
  DiscountRule,
  DiscountRuleName,
  DiscountType,
  ExternalReference,
  FallbackReason,
  FieldViolation,
  GiftCard,
  Group,
  InvalidMembership,
  ItemTaxFullDetails,
  ItemType,
  ItemTypeItemType,
  ItemTypeItemTypeDataOneOf,
  JurisdictionType,
  LineItem,
  LineItemDiscount,
  LineItemPricesData,
  ManualCalculationReason,
  Membership,
  MembershipName,
  MembershipOptions,
  MembershipPaymentCredits,
  MerchantDiscount,
  MerchantDiscountInput,
  MultiCurrencyPrice,
  OtherCharge,
  PaymentOptionType,
  PhysicalProperties,
  PickupDetails,
  PickupMethod,
  PriceSummary,
  RateType,
  Region,
  RuleType,
  Scope,
  SelectedCarrierServiceOption,
  SelectedCarrierServiceOptionOtherCharge,
  SelectedCarrierServiceOptionPrices,
  SelectedMembership,
  SelectedMemberships,
  SelectedShippingOption,
  ServiceProperties,
  ShippingInformation,
  ShippingOption,
  ShippingPrice,
  ShippingRegion,
  StreetAddress,
  SubscriptionFrequency,
  SubscriptionSettings,
  SystemError,
  TaxBreakdown,
  TaxCalculationDetails,
  TaxCalculationDetailsCalculationDetailsOneOf,
  TaxDetails,
  TaxRateBreakdown,
  TaxSummary,
  TaxableAddress,
  TaxableAddressTaxableAddressDataOneOf,
  TaxableAddressType,
  TotalsCalculationEntity,
  V1AdditionalFee,
  V1TaxDetails,
  ValidationError,
  WeightUnit,
} from './ecom-v1-totals-calculation-totals-calculator.universal.js';
